import { type FC } from 'react';
import classNames from 'classnames';
import './HeaderNotificationRowItem.scss';
import {
	HeaderNotificationRowItemResponse,
	NotificationTimeTranslations,
} from '../../../../../../../../../../components/blackrock/advisor-center/_types/header.ts';
import getReadableRelativeTime from './helpers/getReadableRelativeTime.ts';
import LineClamp from '../../../../../../../../../../components/blackrock/advisor-center/line-clamp/LineClamp.tsx';

type Props = Omit<
	HeaderNotificationRowItemResponse,
	'timestamp' | 'id' | 'type' | 'link' | 'refId'
> & {
	/**
	 * timestamp is required in api response, but optional for component (sign in notification)
	 */
	timestamp?: HeaderNotificationRowItemResponse['timestamp'];
	timeTranslations: NotificationTimeTranslations;
	link?: HeaderNotificationRowItemResponse['link'];
};

const HeaderNotificationRowItem: FC<Props> = ({
	timestamp,
	content,
	icon,
	state,
	link,
	timeTranslations,
}) => {
	const isNew = state === 'NEW';

	return (
		<a
			href={link}
			className="header-notification-row-item-link"
			data-final-url={true}
			tabIndex={0}
		>
			<article
				className={classNames('header-notification-row-item', {
					['has-background']: isNew,
				})}
			>
				<div className="dot-wrap">{isNew && <i className="dot" />}</div>

				<div className="icon-wrap">
					<i className={classNames('icon', icon)} />
				</div>

				<section>
					<div className="content">
						<LineClamp lines={3}>{content}</LineClamp>
					</div>
					{!!timestamp && (
						<time className="date" dateTime={new Date(timestamp).toISOString()}>
							{getReadableRelativeTime(timestamp, timeTranslations)}
						</time>
					)}
				</section>
			</article>
		</a>
	);
};

export default HeaderNotificationRowItem;
